import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setViewMode } from '../../store/slices/viewSlice';

const ViewToggle = () => {
  const dispatch = useDispatch();
  const { viewMode } = useSelector(state => state.view);

  const handleViewChange = (mode) => {
    dispatch(setViewMode(mode));
  };

  return (
    <div className="flex items-center bg-white rounded-lg shadow-sm border p-1 ml-auto">
      <button
        onClick={() => handleViewChange('table')}
        className={`flex items-center px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
          viewMode === 'table'
            ? 'bg-blue-100 text-blue-700'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        <svg className="w-4 h-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clipRule="evenodd" />
        </svg>
        Table
      </button>
      <button
        onClick={() => handleViewChange('card')}
        className={`flex items-center px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
          viewMode === 'card'
            ? 'bg-blue-100 text-blue-700'
            : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        <svg className="w-4 h-4 mr-1.5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
        Cards
      </button>
    </div>
  );
};

export default ViewToggle; 